module.exports = function(done, value){
  return {value: value, done: !!done};
};


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/~/core-js/library/modules/$.iter-step.js
// module id = 1535
// module chunks = 243